import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  const [visible, setVisible] = useState(false);
  const [animate, setAnimate] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setAnimate(true));
      });
    } else {
      setAnimate(false);
      const timer = setTimeout(() => setVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  if (!visible) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-439">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm transition-opacity duration-300" style={{
      opacity: animate ? 1 : 0
    }} onClick={onClose} data-id="element-440" />

      {/* Modal content */}
      <div className="relative w-full max-w-2xl max-h-[80vh] bg-card border border-card-border rounded-2xl shadow-2xl flex flex-col overflow-hidden transition-all duration-300 ease-out" style={{
      opacity: animate ? 1 : 0,
      transform: animate ? 'scale(1) translateY(0)' : 'scale(0.95) translateY(20px)'
    }} data-id="element-441">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-card-border shrink-0" data-id="element-442">
          <h2 className="text-xl font-bold text-white" data-id="element-443">{title}</h2>
          <button onClick={onClose} className="w-10 h-10 rounded-full bg-background flex items-center justify-center text-gray-400 hover:text-white hover:bg-card-border transition-colors" aria-label="Cerrar" data-id="element-444">
            <XIcon className="w-5 h-5" data-id="element-445" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto text-gray-300 leading-relaxed space-y-4" data-id="element-446">
          {children}
        </div>
      </div>
    </div>;
}